<template>
  <div class="container">
    <p>《新奇天户外隐私协议》<br/>首次版本发布时间：2025年【4】月【20】日<br/>最新版本更新时间：2025年【4】月【20】日<br/>最新版本生效时间：2025年【4】月【20】日<br/><br/><br/>您（也称“用户”）正在访问由超悦奇（上海）科技有限公司（以下简称“超悦奇”或“我们”）运营、管理及/或维护的“新奇天户外”应用程序（以下统称为“新奇天户外”或“本应用”）！我们深知个人信息对您的重要性，您的信任对我们非常重要，我们将根据法律法规要求为您的个人信息安全提供充分保障。鉴于此，我们制定《新奇天户外隐私协议》（以下简称“本协议”）以帮助您充分了解在您使用我们的产品与/或服务时，我们如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。<br/>本协议将帮助您了解以下内容：<br/>一、我们如何收集和使用您的个人信息<br/>二、我们如何使用Cookies和同类技术<br/>三、我们如何共享、转让、公开披露您的个人信息<br/>四、我们如何存储和保存您的个人信息<br/>五、您如何管理个人信息<br/>六、未成年人的个人信息保护<br/>七、通知和修订<br/>八、如何联系我们<br/><strong>本协议适用于我们提供的产品或服务。在使用本应用服务前，请您务必仔细阅读和理解本协议，特别是以粗体/粗体下划线标识的条款，您应重点阅读，确认您充分理解并同意后再开始使用。如果您不同意本协议的内容，您应立即停止使用我们的游戏服务。如您通过注册程序并【勾选】同意本协议，即视为您同意本协议的内容，与我们已达成协议，自愿接受本协议的约束。</strong><br/>我们将担任“个人信息处理者”，亦即我们将决定“为何”和“如何”收集和使用您个人信息的。我们的“个人信息受托者”则是由我们指示“为何”和“如何”可以代替我们处理您个人信息的机构。<br/>为提供我们的产品及服务给您，我们需要和我们的“个人信息受托者”，即认可的商业伙伴或我们的共享您的个人信息。他们均负有采用适当安全措施以保护所持个人信息的义务，受严格的保密义务所规范，且“为何”和“如何”可以代替我们处理您个人信息均受相关合同条款所约束。<br/>本协议不适用于您通过我们的产品或服务而接入的其他第三方产品/服务，具体规定请参照该第三方的隐私协议或类似规则。<br/>如对本协议内容有任何疑问、意见或建议，您可通过文末联系方式与我们联系。 <br/> <br/>第一部分 隐私协议<br/>一、我们如何收集和使用您的个人信息<br/><strong>个人信息</strong>是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。<strong>个人敏感信息</strong>是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息。<br/>本协议中涉及的个人信息包括：<strong>手机号、生日、性别、</strong>位置信息（包括粗略位置信息和<strong>详细位置信息）</strong>、<strong>可能带有您个人或他人肖像的照片</strong>等；<strong>其中，字体加粗部分为涉及的个人敏感信息。</strong><br/>我们会通过如下渠道获取您的个人信息：<br/><strong>（一）您授权我们收集和使用您个人信息</strong><br/>1.注册及登录账户<br/>为了向您提供新用户注册以及老用户登录的服务，在此过程中，您需要向我们提供账号注册信息及联系方式。具体包括账户名、您本人的<strong>手机号码</strong>以及您在特定活动中主动提供的任何信息。<br/>例如，当您首次注册账号时，账户名和<strong>手机号码</strong>是必填项，这些信息将帮助我们识别您的身份，以便为您提供本应用服务。<br/>如您选择第三方账号登录本应用时，则我们会收集来自微信等第三方平台的您的第三方账号信息，例如头像、昵称、账号ID。<br/>请您知悉，如您拒绝提供前述账号注册及登录信息，您将无法使用本应用服务。<br/>2. 向您提供广告及服务信息展示<br/>1）信息浏览、发布、收藏、评价、分享功能。当您成功注册账号后，您可以浏览本应用内用户发布的路线；您可在本应用内发布文字、图片；您可在本应用内对别人分享的徒步路线使用收藏、下载等功能。为了向您提供我们最核心的信息展示和信息发布服务，我们会收集您的设备型号、设备名称、设备唯一标识符、本机应用列表、浏览器类型和设置、操作系统和应用程序版本、登录IP地址、接入网络的方式、网络质量数据、移动网络信息（包括运营商名称）、产品版本号、日志信息（如操作日志、服务日志）。<br/>2）当您使用发布、编辑内容功能时，我们会请求您授权存储（相册、媒体和其他文件）、相机（摄像头）。您如果拒绝授权提供，将无法使用相应功能，但不影响您正常使用本应用的其他功能。<br/>当您使用发布功能时，您发布的文字、照片、收藏信息会存储在我们的服务器中，因为存储是实现这一功能所必需的。我们会以加密的方式存储，您也可以随时删除这些信息。<br/>3）搜索功能。当您使用搜索功能时，我们会收集您查询的关键词、阅读记录和访问时间、评论和互动记录。<br/>4）基于地理位置的功能服务 。当您通过系统授权开启移动设备的定位功能并使用本应用基于地理位置提供的相关服务（包括基于地理位置的内容推荐、内容发布时的位置定位、资料编辑、徒步路线记录）时，我们会收集和使用您的<strong>详细位置信息</strong>，以便为您提供上述服务。您可以在移动设备的系统中关闭定位服务停止我们对您所在位置信息的收集，但不影响您正常使用本应用的其他功能。我们也仅会基于网络信息（如IP）、或经过您授权的相应地理位置信息对应的城市及/或区县及/或街道向您展示可能相关的内容或服务。<br/>5）设备信息。我们会根据您在软件安装及使用中的具体操作，接收并记录您所使用的设备相关信息(包括设备型号、操作系统版本、设备设置、唯一设备标识符、使用的移动应用和其他软件信息等软硬件特征信息) ，设备所在位置相关信息(包括您授权的GPS位置以及WLAN接入点、蓝牙和基站、陀螺仪传感器、加速度传感器、重力传感器、sim卡激活信息等传感器信息)。<br/>3.沟通与纠纷解决<br/>为了提升用户体验，解决用户在使用本应用过程中所遇到的问题，我们会收集您通过“在线客服”以及其他形式调查提交给我们的沟通信息。<br/>当您与我们的在线客服进行文字沟通时，或者通过其他形式的调查向我们反馈问题时，我们会收集这些文字沟通信息。这些信息将帮助我们更好地了解您的需求和问题，以便为您提供更优质的服务，解决交易纠纷，保障您的权益。<br/>4.设备权限调用汇总<br/>当我们提供本应用服务时，会调用您的主要设备权限汇总如下。您可以在设备的设置功能中选择关闭部分或全部权限。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引:<br/>1）通知<br/>对应业务功能：系统通知<br/>功能场景说明：本应用相关消息推送<br/>是否可关闭：可以，关闭后仅影响对应功能，不影响本应用其他功能<br/>2）网络权限<br/>对应业务功能：上网功能<br/>功能场景说明：开启上网功能，实时读取与更新<br/>是否可关闭：可以，关闭后本应用内容无法实时读取与更新，无法正常使用本应用<br/>3）相机（摄像头）<br/>对应业务功能：拍摄照片；消息<br/>功能场景说明：发布内容时进行拍摄；<br/>是否可关闭：可以，关闭后仅影响对应功能，不影响本应用其他功能<br/>4）地理位置<br/>对应业务功能：内容推荐；内容发布；资料编辑<br/>功能场景说明：根据用户所在位置推荐内容，如附近功能的地图展示功能；用户发布内容时定位所在区域，如发布定位标签、使用标记功能；个人页编辑地区<br/>是否可关闭：可以，关闭后仅影响对应功能，不影响本应用其他功能<br/>5）存储（相册、媒体和其他文件）<br/>对应业务功能：内容发布；内容保存；消息；分享；资料编辑；客服沟通与意见反馈<br/>功能场景说明：发布内容时读取相册和媒体内容、进行存储；日志信息记录、信息缓存；发布图片消息时读取相册内容；截图分享时进行存储；编辑资料选择头像图片时读取相册内容；用 “联系客服”或“意见反馈” 功能时读取相册内容<br/>是否可关闭：可以，关闭后仅影响对应功能，不影响本应用其他功能<br/>6）健康权限<br/>对应业务功能：记录我的徒步数据<br/>功能场景说明：当用户记录徒步数据时，需要获取用户的心率、卡路里等信息，以保证运动记录的完善<br/>是否可关闭：可以，关闭后仅影响对应功能，不影响本应用其他功能<br/>7）实时活动<br/>对应业务功能：帮助用户在锁屏状态下依然可以精准记录徒步数据<br/>功能场景说明：锁屏状态下，仍可以看到当前徒步记录的总里程、总时长信息<br/>是否可关闭：可以，关闭后仅影响对应功能，不影响本应用其他功能<br/>8）设备状态（包括设备信息和运行状态）<br/>对应业务功能：内容推荐；展示和其他功能优化<br/>功能场景说明：展示和其他功能优化<br/>是否可关闭：不可以<br/><br/><br/>9）应用自启动或关联启动行为说明<br/>- 设备重启后的服务恢复 对应业务功能：当您的设备重启后，如果您之前正在进行徒步记录且记录未完成，应用会自动启动以恢复徒步记录服务；通知服务会在设备重启后自动启动，以确保您能收到重要的应用通知<br/>功能场景说明：继续未完成的徒步记录；应用通知<br/>是否可关闭：可以，但需以前序行为的功能授权情况为准，不可独立设置重启授权  - 应用启动时的后台服务初始化 对应业务功能：当您打开新奇天户外应用时，会自动启动必要的后台服务，包括定位服务（精确定位服务会优先征得您的同意后启用）、计时服务等<br/>功能场景说明：支持徒步记录、导航等核心功能 是否可关闭：可以，关闭后仅影响对应功能，不影响本应用其他功能<br/> - 快捷操作触发启动 对应业务功能：当您通过桌面快捷操作（如3D Touch或长按应用图标）选择&quot;开始徒步&quot;时，会启动相关的后台服务<br/>功能场景说明：快速启动应用服务<br/>是否可关闭：可以，关闭后仅影响对应功能，不影响本应用其他功能 <br/><br/><br/><strong>（二）我们可能从第三方间接获取您的个人信息</strong><br/>请您知悉，您向外部第三方提供的个人信息，或外部第三方收集的您的个人信息，我们无法获取，更不会使用非常规方式盗取您的个人信息。如果因业务发展的必要而需要从第三方间接收集（如共享等）您的个人信息的，且由我们直接或间接（联合）为您提供产品或服务的，我们（或第三方）在收集前会向您明示共享的您个人信息的来源、类型、使用目的、方式和所用于的业务功能、授权同意范围（如果使用方式和范围超出您在第三方原授权范围的，我们会再次征得您的授权同意），包括您通过第三方账户直接登录我们的产品与/或服务时，我们从第三方获取的您授权共享的账户信息（包括头像、昵称）、我们的某些产品/服务由业务合作伙伴提供或者我们与业务合作伙伴共同提供时，为了必要/合理的业务的顺利开展，我们从部分业务合作伙伴处间接收集的您的部分信息、其他方使用我们的产品与/或服务时所提供有关您的信息（包括发布的与您相关的内容，包括图片、文字等信息）。<br/><strong>（三）征得同意的例外</strong><br/>您应充分知晓，原则上我们仅在取得您的同意的前提下，才会收集、使用或以其他方式处理您的个人信息，但在以下情形中，我们收集、使用个人信息<strong>无需征得您的授权同意</strong>：<br/>1.与国家安全、国防安全有关的；<br/>2.为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；<br/>3.为履行法定职责或者法定义务所必需；<br/>4.为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；<br/>5.为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；<br/>6.依照本法规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；<br/>7.法律、行政法规规定的其他情形。<br/><strong>（四）个人信息使用规则</strong><br/>1.我们会根据本协议的约定，为实现我们的产品与/或服务功能而对所收集的个人信息进行使用。<br/>2.在收集您的个人信息后，我们将通过技术手段对部分信息进行去标识化处理，去标识化处理的信息将无法识别主体。<strong>请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。</strong><br/>3.请您了解并同意，对于您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将被视为在您使用我们的产品与/或服务期间持续授权同意我们使用。在您注销账号时，我们将停止使用并删除您的个人信息。<strong>请您知悉，我们可能不会将相应的信息立即从备份系统中删除，但会在备份系统更新时进行删除。</strong><br/>4.当我们要将您的个人信息用于本协议未载明的其它用途时，或基于特定目的收集而来的个人信息用于其他目的时，会事先征求您的明示同意。<strong>请您理解，我们向您提供的产品与/或服务将不断更新变化。如果您选择使用本协议中尚未列明的其他产品与/或服务时，我们会在收集您的个人信息前通过协议、页面提示等方式向您详细说明信息收集的目的、方式、范围并征求您的同意。若您不同意提供前述信息，您将无法使用该项产品与/或服务，但不影响您使用现有产品与/或服务。</strong><br/>5.<strong>当您使用本应用记录徒步路线时，相关路线信息拟进行公开共享，届时将面向全部用户可见。</strong>在实际公开共享前，我们会以弹窗形式向您征求同意，您可自主选择是否授权。<br/> <br/><strong>二、我们如何使用Cookies和同类技术</strong><br/>为提高您的使用体验，我们会使用Cookies或类似技术（例如：web beacons, log files, scripts, eTags）(以下统称“Cookies技术”)。Cookie技术是互联网行业普遍使用的技术。<br/>我们或我们的第三方合作伙伴，可能通过放置安全的Cookie技术收集您的信息，并将该等信息存储为日志信息，以便为您提供更好的用户体验和服务。我们会严格要求第三方合作伙伴遵守本政策的相关规定。<br/>Cookies、标识符等同类技术，将用于以下用途：<br/>1、记住您的身份。Cookies或同类技术有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供有关您的喜好或其他信息；<br/>2、分析您使用我们服务的情况。我们可利用Cookies或同类技术来了解您使用我们服务的方式，以求改善用户体验，例如哪些功能可能存在不稳定运行的问题；<br/>3、广告优化。Cookies或同类技术有助于我们根据您的信息，向您提供您可能更感兴趣的广告而非进行普遍的广告投放。<br/><strong>我们为上述目的使用Cookies或同类技术的同时，可能将通过Cookies或同类技术收集的非个人身份信息汇总提供给广告商和其他伙伴，用于分析您和其他用户如何使用我们提供的游戏服务并用于广告服务。</strong><br/><strong>您可以通过浏览器或用户选择机制拒绝或管理Cookies或同类技术。但请您注意，如果您停用Cookies或同类技术，我们有可能无法为您提供更优质的服务体验，某些服务也可能无法正常使用。同时，您仍然将收到广告，只是这些广告与您的相关性会降低。</strong><br/> <br/><strong>三、我们如何共享、转让、公开披露您的个人信息</strong><br/><strong>（一）共享</strong><br/>我们不会与非服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：<br/>1.在您主动选择情况下共享：若您主动通过我们购买商品和服务，我们会根据您的选择，将您的订单信息与交易有关的必要信息与相关商品和服务的提供者共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。您可以在相关商品和服务的提供者从事经营活动的主页面查询营业执照登载的主体信息，以辨别的您的交易对象身份。<br/>2.在获取明确同意情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。例如，如果我们委托第三方向您提供产品或服务时，我们会在征得您同意后将上述信息共享给第三方，如果您拒绝提供此类信息，我们将无法完成相关交付服务。<br/>3.在法定情形下共享：我们会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。<br/>4.与授权合作伙伴共享：我们可能会委托授权合作伙伴为您提供某些服务或代表我们履行职能，在此之前我们会和他们通过不限于签订协议的方式约定双方的权利和义务。我们仅会出于合法、正当、必要、特定、明确的目的处理您的信息，授权合作伙伴只能接触到为其履行职责所需信息，且不能将此信息用于任何其他目的。<br/><strong>您理解并知悉，为了向您提供更完善、优质的产品和服务，我们将授权商业合作伙伴为您提供部分服务。此种情形下，我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。</strong>请您注意，我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们将对信息数据的输出形式、流转、使用进行安全评估与处理，以保护数据安全。同时，我们会对合作伙伴进行严格的监督与管理，一旦发现其存在违规处理个人信息的行为，将立即停止合作并追究其法律责任。<br/>目前，我们的合作伙伴包括以下类型：<br/>A.广告和统计分析类合作伙伴：为帮助进行广告或决策建议、提高广告有效触达率、进一步了解用户需求，我们可能会与委托我们进行信息推广和广告投放的合作伙伴、或统计分析类合作伙伴共享去标识化的设备信息或统计信息，这些信息难以或无法与您的真实身份相关联。请您知悉，为了您的信息安全，我们目前仅与已签署严格数据安全保密协议的合作伙伴进行合作。<br/>B.内容审核服务商：为保证用户在互联网信息平台上发布的内容是安全的，我们可能会向委托的第三方内容审核服务商共享您在本应用内发布的内容信息。<br/>C.合作的第三方SDK服务商：当您使用新奇天户外平台中由第三方提供的功能时，我们可能会接入由第三方提供的软件开发包（SDK）以实现相关功能。<br/>D.与我们的关联公司必要共享：我们可能会与我们的关联公司共享您的个人信息。我们只会共享必要的个人信息，且这种共享受本政策所声明的目的的约束。关联公司如要改变个人信息的处理目的，将再次征得您的授权和同意或基于法律法规下的合法依据使用。<br/><strong>（二）转让</strong><br/>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<br/>1.事先获得您明确的同意或授权；<br/>2.根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；<br/>3.符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；<br/>4.随着我们业务的发展，我们及我们的关联方有可能进行合并、收购、资产转让或类似的交易，<strong>如涉及个人信息的转让，我们会要求受让您个人信息的公司、组织继续接受本协议的约束，否则,我们将要求该公司、组织重新征求您的授权同意。</strong><br/><strong>（三）公开披露</strong><br/>我们仅会在以下情况下，公开披露您的个人信息：<br/>1.获得您明确同意或基于您的主动选择，我们会公开披露您的个人信息；<br/>2.根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函，并且我们披露的文件均是加密后提供。<br/><strong>（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</strong><br/>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：<br/>1.与我们履行法律法规规定的义务相关的；<br/>2.根据法律法规的规定或行政、司法机构、国家部门等有权机关的要求依法提供的；<br/>3.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br/>4.您自行向社会公众公开的个人信息；<br/>5.与国家安全、国防安全直接相关的；<br/>6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。<br/>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。<br/> <br/><strong>四、我们如何存储和保护您的个人信息</strong><br/><strong>（一）存储</strong><br/>1.存储地点：我们将从运营本应用中获得的个人信息存放于中华人民共和国境内。以下情形下，我们会确保在履行了法律规定的义务后，向中华人民共和国境外实体提供您的个人信息：<br/>（1）适用的法律有明确规定;<br/>（2）获得您的明确授权; 或<br/>（3）您通过互联网进行跨境交易等个人主动行为。<br/>针对以上情形，我们会通过合同等形式确保以不低于本政策规定的程度保护您的个人信息。<br/>2.存储时间：我们承诺始终按照法律的规定在合理必要期限内在存储您个人信息。超出上述期限后，我们将删除您的个人信息或对您的个人信息进行匿名化处理。<br/>如我们停止运营，我们将及时停止收集您个人信息的活动，会尝试将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。<br/><strong>（二）保护</strong><br/>为了保护您的个人信息安全，我们将努力采取各种符合行业标准的安全措施来保护您的个人信息以最大程度降低您的个人信息被毁损、盗用、泄露、非授权访问、使用、披露和更改的风险。我们将积极建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用，确保未收集与我们提供的服务无关的个人信息。<br/>您的账号均有安全保护功能，请妥善保管您的账号及密码信息。我们将通过向其它服务器备份、对用户密码进行加密及相关安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意不存在“完善的信息安全措施”。为协助防止安全事故的发生，我们已按照法律法规的规定，制定了预警机制和应急预案。如确发生安全事件，我们将及时将相关情况选择以邮件、信函、电话、推送通知及按法律要求的相关方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况，紧密配合政府机关的工作。<br/>当我们的产品或服务发生停止运营的情形时，我们会及时停止继续收集个人信息的活动。上述变更，我们将尝试以推送通知、公告及相关形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理（所谓“匿名化处理”，是指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。个人信息经匿名化处理后所得的信息不属于个人信息。）<br/><br/><br/><strong>五、您如何管理个人信息</strong><br/><strong>（一）查询、更正和补充您的个人信息</strong><br/>您有权查询、或补充您的信息。您可以通过以下方式自行进行：<br/>1）在个人中心-个人资料模块，进行头像、昵称等信息的修改。<br/>2）其他您无法查看或更正的信息请线上客服寻求帮助，协助您查询、更正或补充您的信息。<br/><strong>（二）删除您的个人信息</strong><br/>在以下情形中，您可以向我们提出删除个人信息的请求：<br/>1.如果我们处理个人信息的行为违反法律法规；<br/>2.如果我们收集、使用您的个人信息，却未征得您的明确同意；<br/>3.如果我们处理个人信息的行为严重违反了与您的约定；<br/>4.如果您不再使用我们的产品或服务，或您主动注销了账号；<br/>5.如果我们停止为您提供产品或服务。<br/>若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。<br/>当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。<br/><strong>（三）改变您授权同意的范围或撤回您的授权</strong><br/>每个业务功能需要一些基本的个人信息才能得以完成，参见“一、我们如何收集和使用您的个人信息”。除此之外，您可以在设置界面或与客服联系等方式给予或收回您的授权同意。<br/>您也可以通过设备本身操作系统变更或撤回您对麦克风（录音）、通知、网络、相机（摄像头）、地理位置、相机（摄像头）、存储（相册、媒体和其他文件）、电话状态权限的授权，不同设备型号的功能可能不尽相同，我们将根据您变更或撤回授权的设置进行个人信息的收集，如您撤回授权我们将不再收集与这些权限相关的信息。<br/><strong>请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响我们此前基于您的同意或授权已进行的个人信息处理活动。</strong><br/><strong>（四）注销账号</strong> 您可以通过【个人中心-账号管理】或联系在线客服，在满足账号注销的条件下选择【申请注销账号】，来注销您的账号；我们会在收到您的注销申请并验证您的用户身份后十五个工作日内尽快为您处理。账号注销后，除法律明确规定必须由我们保留的个人信息外，您的个人信息将会从本应用内移除。<br/><strong>（五）响应您的请求</strong><br/>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们将会先要求您验证自己的身份，然后再处理您的请求。<br/>我们将在十五个工作日内做出答复。如您不满意，还可以通过我们客服发起投诉，我们客服收到投诉后会在24小时内响应。<br/>对于您合理的请求，我们原则上不收取费用，但<u>对多次重复、超出合理限度的请求，我们将酌情收取一定费用。</u>对于与您的身份不直接关联的信息、无端重复信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。<br/>在以下情形中，按照法律法规要求，我们将无法响应您的请求：<br/>1.与我们履行法律法规规定的义务相关的；<br/>2.与国家安全、国防安全有关的；<br/>3.与公共安全、公共卫生、重大公共利益有关的；<br/>4.与犯罪侦查、起诉、审判和执行判决等有关的；<br/>5.有充分证据表明个人信息主体存在主观恶意或滥用权利的；<br/>6.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；<br/>7.涉及商业秘密的。<br/> <br/><strong>六、未成年人的个人信息保护</strong><br/><strong>（一）我们如何收集、使用未成年人个人信息</strong><br/><strong>请您知悉，本应用和本应用提供的服务并非指向、针对，或为未成年人使用目的而提供，因此在我们无法自动识别和判断所收集和处理的个人信息是否属于未成年人个人信息时，我们将按照本协议收集和处理用户的个人信息</strong>，但如果用户通过实名认证或者其他方式使得我们获悉用户的未成年人身份后，我们将提醒用户在监护人的同意或者陪护和指导下使用本应用服务，如适用法律要求。此外，我们将依据本政策和法律法规的要求，对涉及未成年人个人信息的账号采取特殊保护措施。<br/><strong>不满14周岁的未成年人（即“儿童”），如果没有父母或监护人的同意，儿童不得创建自己的用户账户。</strong>如您为儿童的，建议您与您的父母或监护人仔细阅读本协议与《儿童隐私保护指引》，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。<br/>对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。<br/>若您是未成年人的监护人，当您对您所监护的未成年人使用我们的服务或其向我们提供的用户信息有任何疑问时，请您根据本协议第八条提供的联系方式及时与我们联系。<br/><strong>（二）我们如何保护未成年人的个人信息</strong><br/>为了确保未成年人个人信息对外提供的安全性，一般情况下我们不会委托第三方处理未成年人个人信息。如确需委托第三方处理未成年人个人信息时，我们将对受托方个人信息保护资质能力及受托处理行为进行安全评估，同时签署数据委托处理协议，明确双方责任处理事项、处理期限、处理性质和目的，保证委托行为不得超出授权范围。<br/> <br/><strong>七、通知和修订</strong><br/>我们保留随时更新本协议的权利。当决定对隐私协议进行更新时，我们会在本应用内公布更新内容，这些更新将作为隐私协议的一部分。如果我们对处理您的个人信息的方式做出重大调整，我们会明确征求您的同意。在未得到您的同意的情况下，我们不会减少您根据本协议所享有的任何权利。<br/>对于重大变更，我们还会提供更为显著的通知（例如向您提供<strong>弹窗提示</strong>）。<br/>本协议更新公示后7日后即生效。请您仔细阅读变更后的隐私协议内容。如果您不同意本协议，或对本协议修改、更新的内容有异议，您可以选择停止使用本应用服务或者注销帐号。如您在本协议更新生效后继续使用我们的服务，即代表您已充分阅读、理解并接受更新后的声明并愿意受更新后的声明约束。<br/>本协议所指的重大变更包括但不限于：<br/>1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；<br/>2.我们在控制权等方面发生重大变化。如并购重组等引起的信息控制者变更等；<br/>3.个人信息共享、转让或公开披露的主要对象发生变化；<br/>4.您参与个人信息处理方面的权利及其行使方式发生重大变化；<br/>5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；<br/>6.个人信息安全影响评估报告表明存在高风险。<br/> <br/><strong>八、如何联系我们</strong><br/>如您对本协议内容有任何疑问，或您对本协议的执行以及对我们个人信息保护相关事宜有任何咨询、投诉、建议，或发现您的个人信息可能被泄露或您觉得需要撤回、更正、删除您的个人信息授权，<u>您可以通过本应用页面中的“联系客服”联系我们。</u><br/>我们将在收到您的请求15天内或适用的法律法规要求的时限内回复您的请求。<br/><strong><u>如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向上海市徐汇区人民法院提起诉讼来寻求解决方案。</u></strong><br/><br/><br/>第二部分 儿童隐私保护指引<br/>欢迎您使用超悦奇（上海）科技有限公司(下列简称为“超悦奇”或“我们”)提供的“新奇天户外”应用服务。我们深知儿童（指未满十四周岁的未成年人）个人信息和隐私安全的重要性，希望通过《儿童隐私保护指引》（以下简称“本指引”）说明我们在收集和使用儿童个人信息时对应的处理规则等相关事宜。<strong>在使用我们的产品和服务（以下统称“我们的服务”）前，请儿童以及儿童的父母或其他监护人（以下统称“监护人”）务必仔细阅读并透彻理解本指引，特别是以粗体/下划线标识的条款应重点阅读，在确认充分理解并同意全部条款后再开始使用</strong>。<br/><strong>儿童监护人特别说明：</strong><br/><u>若我们获悉监护人的儿童不满14周岁，我们将根据本指引采取特殊措施保护监护人儿童的个人信息。我们希望监护人与我们共同保护儿童的个人信息，教育引导儿童增强个人信息保护意识和能力，指导、提醒和要求他们在未经监护人同意的情况下，不向任何网络产品和服务提供者提供任何个人信息。<strong>如果监护人不同意本指引的内容，将可能导致我们的服务无法正常运行，或者无法达到我们拟达到的服务效果，监护人应要求监护人的儿童立即停止访问/使用我们的服务。监护人于线上点击同意本指引，或者监护人的儿童使用/继续使用我们的服务、提交个人信息，都表示监护人同意我们按照本指引（包括更新版本）收集、使用、储存、分享、转让和披露监护人儿童的个人信息</strong>。</u><br/><strong>儿童特别说明：</strong><br/><u>我们建议：任何儿童参加网上活动都应事先取得监护人的同意。如果您是14周岁以下的未成年人，您需要和您的监护人一起仔细阅读本指引，并在征得您的监护人同意后，使用我们的产品、服务或向我们提供信息。您于线上点击同意本指引，或者您使用/继续使用我们的服务、提交个人信息，都表示您已获得您的监护人的许可，您的监护人均同意我们按照本指引（包括更新版本）收集、使用、储存、分享、转让和披露您的个人信息。</u><br/>在阅读完本指引后，如对本指引或与本指引相关的事宜有任何问题，可通过<u>本指引“如何联系我们”</u>章节所列的反馈渠道联系我们，我们会尽快作出解答。<br/><strong>本指引包含内容</strong><br/>一、儿童个人信息的收集和使用<br/>二、儿童个人信息的共享、转移、披露<br/>三、儿童个人信息的存储和保护<br/>四、儿童个人信息的管理<br/>五、本指引的适用<br/>六、本指引的变更<br/>七、如何联系我们<br/><br/><br/><strong>一、儿童个人信息的收集和使用</strong><br/>1、我们会严格履行法律法规规定的儿童个人信息保护义务与责任，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则。<br/>2、我们仅会收集儿童监护人同意我们收集的或儿童监护人主动提供的有关儿童的个人信息，以向儿童监护人的提供、优化我们的服务以及保障儿童的账户安全。我们可能会收集的您孩子的个人信息的详情，请参见上述《第一部分 隐私协议》<br/>3、鉴于我们提供的服务不面向未满14周岁的用户，<strong>在服务中，我们会根据用户填写的身份证号</strong>，识别该用户是否为儿童。若我们识别用户为儿童，将会拒绝提供相关产品或服务。<br/>4、为了更好地保护儿童的权益，验证儿童监护人与儿童的监护关系的存在，我们可能会收集监护人的联系方式，<strong>包括手机号码、电子邮箱</strong>，以及相关身份关系证明，包括<strong>姓名、身份证、户口本或其他监护关系证明</strong>。<br/>5、我们严格遵守法律法规的规定和与用户的约定，将收集儿童的信息用于以下用途：<br/>（1）验证儿童和监护人身份；<br/>（2）提供必要的产品或服务、产品或服务的具体功能；<br/>（3）用于优化产品或服务、安全保障、服务调查目的。<br/>6、在儿童使用我们的服务过程中，我们可能还会收集和使用其他儿童个人信息，具体请查阅<u>《新奇天户外隐私协议》“我们如何收集和使用您的个人信息”</u>一节，详细了解我们可能收集的其他儿童个人信息。<br/>如果我们需要超出上述用途使用监护人或儿童的个人信息，我们将再次征得监护人的同意。<br/><strong>7、由儿童或监护人提供或我们收集的儿童信息中，可能包含儿童的个人敏感信息，例如身份证件号码、个人生物识别信息、银行账号、通信记录和内容、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息。请监护人和儿童谨慎提供并留意儿童个人敏感信息，监护人同意我们可以按本指引所述的目的和方式来处理儿童相关个人敏感信息</strong>。<br/><strong>二、儿童个人信息的共享、转移、披露</strong><br/>我们遵照法律法规的规定，严格限制共享、转移、披露儿童个人信息的情形。一般情况下，我们不会向第三方分享儿童的个人信息。我们仅在监护人事先同意的情况下，才可能与第三方分享儿童的个人信息。<br/><strong>（一）共享</strong><br/>1、我们会将部分儿童个人信息（如儿童用户名、账号、密码，以及该儿童用户在我们某些产品和服务中的交易内容等）与监护人进行分享，监护人可以访问和管理相关个人信息。<br/><strong>2、为实现我们外部处理的目的，我们可能向合作伙伴及其他第三方分享儿童的信息，例如：提供实名认证服务的第三方机构、提供支付服务的支付机构、提供数据服务（包括网络广告监测、数据统计、数据分析）的合作伙伴和其他服务提供商</strong>。<br/>如我们委托第三方处理儿童个人信息的，我们会对受委托方及委托行为等进行安全评估，签署委托协议，要求受委托方的处理行为不得超出我们的授权范围，我们委托第三方处理儿童个人信息用于以下用途：<br/>（1）向儿童提供我们的服务；<br/>（2）实现<u>“我们收集和使用个人信息的方式、目的及范围”</u>部分所述目的；<br/>（3）履行我们在<u>《新奇天户外隐私协议》</u>和本指引中的义务和行使我们的权利；<br/>（4）理解、维护和改善我们的服务。<br/>如我们与上述第三方分享儿童的信息，我们将进行安全评估并采用加密、匿名化、去标识化处理等手段保障儿童的信息安全。<br/><strong>（二）转让</strong><br/>1、<strong>随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而儿童的信息有可能作为此类交易的一部分而被转移</strong>。我们将通过推送通知、公告等形式告知监护人相关情形，并进行安全评估，要求新的持有儿童个人信息的平台、组织继续受本指引的约束，否则，我们将要求该平台、组织重新向监护人征求授权同意。<br/>2、在获得监护人的同意后，我们会向其他方转让儿童个人信息。<br/><strong>（三）披露</strong><br/>1、根据儿童或监护人的需求，在监护人同意的披露方式下披露其所指定的信息。<br/>2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供儿童信息的情况下，我们可能会依据所要求的信息类型和披露方式披露儿童的信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。<br/><strong>（四）分享、转让、披露信息时事先征得授权同意的例外</strong><br/>以下情形中，分享、转让、披露儿童的信息无需事先征得监护人的授权同意：<br/>（1） 为履行法定职责或者法定义务所必需；<br/>（2） 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；<br/>（3） 为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；<br/>（4） 根据法律法规在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；<br/>（5） 您要求签订和履行合同所必需；<br/>（6） 法律法规规定的其他情形。<br/><strong>根据法律规定，共享、转让、披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向监护人通知并征得监护人的同意。</strong><br/><strong>三、儿童个人信息的存储和保护</strong><br/><strong>（一）儿童个人信息的存储</strong><br/><strong>我们仅在本指引所述目的所必需期间和法律法规要求的最短时限内储存儿童个人信息</strong>。<br/>超出法律法规或监管规定的期限后，我们会按照法律法规的要求对您孩子的个人信息进行删除或者匿名化处理。<br/><strong>（二）儿童个人信息的保护</strong><br/><strong>我们非常重视儿童的隐私安全，成立了专门的安全团队，并采取一切合理可行的措施，保护儿童个人信息：</strong><br/>我们会采取加密等技术措施储存儿童个人信息，确保信息安全。同时，我们对工作人员以最小授权为原则，严格设定信息访问权限，控制儿童个人信息知悉范围；工作人员访问儿童个人信息的，须经过儿童个人信息保护负责人或者其授权的管理人员审批，记录访问情况，并采取技术措施，避免违法复制、下载儿童个人信息。如我们发现儿童个人信息发生或者可能发生泄露、毁损、丢失的，会立即启动应急预案，采取补救措施，并将事件相关情况以邮件、信函、电话、推送通知、公告等方式告知受影响的监护人和儿童。<br/><strong>四、儿童个人信息的管理</strong><br/>如儿童和/或儿童监护人想要查询、复制、更正、补充、删除或撤回儿童的个人信息，您可以联系客服遵循相关操作指引进行处理。<br/>除法律法规另有规定，当监护人和儿童更正、删除儿童个人信息或申请注销账号时，我们可能不会立即从备份系统中更正或删除相应的信息，但会在备份更新时更正或删除这些信息。<br/><strong>五、本指引的适用</strong><br/><strong>本指引适用于我们在中华人民共和国境内通过网络从事收集、使用、储存、分享、转让和披露不满14周岁儿童的个人信息等活动。当儿童使用任何我们的服务时，监护人同意接受本指引以及我们在该单项服务中发出的特定儿童个人信息保护类特定条款，在此情况下特定条款与本指引条款同时对监护人和儿童产生效力。如特定条款与本指引条款存在同类条款的不一致约定，则在特定条款约束范围内应以特定条款为准。如我们提供的某一单项服务不适用本指引的，该服务中会以适当方式明示排除适用本指引。在儿童个人信息保护规则方面，本指引与《新奇天户外隐私协议》正文存在不一致的，本指引优先适用，如本指引中未提及的，则以《新奇天户外隐私协议》为准。</strong><br/><strong>六、本指引的变更</strong><br/>我们可能会适时对本指引进行修订。当本指引的条款发生变更时，我们会在版本更新时以适当的方式向您提示变更后的指引。请您仔细阅读变更后的隐私保护指引内容<br/><strong>七、如何联系我们</strong><br/>监护人可以通过以下方式与我们联系：<br/>1、如对本指引内容有任何疑问、意见或建议,监护人可以联系我们在线客服。<br/>一般情况下，我们将在收到问题、意见或建议，并验证监护人与儿童身份后的十五个工作日内予以回复。<br/>2、我们设立了个人信息保护专员，监护人可通过客服邮箱与我们联系。<br/>联系方式：【hi@allreaday.com】<br/><br/></p>  </div>

  <div class="personal-info-collection">
    <div class="header">
      <h1>个人信息收集清单</h1>
    </div>

    <div class="table-container">
      <div class="table-wrapper">
        <table class="info-table">
          <thead>
          <tr>
            <th>信息类型</th>
            <th>具体内容</th>
            <th>收集目的</th>
            <th>使用场景</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in personalInfoData" :key="index">
            <td>{{ item.infoType }}</td>
            <td>{{ item.specificContent }}</td>
            <td>{{ item.collectPurpose }}</td>
            <td>{{ item.useScene }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="third-party-info-sharing">
    <div class="header">
      <h1>第三方信息共享清单</h1>
    </div>

    <div class="table-container">
      <div class="table-wrapper">
        <table class="info-table">
          <thead>
          <tr>
            <th>SDK名称</th>
            <th>第三方主体</th>
            <th>共享的信息</th>
            <th>使用场景</th>
            <th>权限使用</th>
            <th>使用目的</th>
            <th>采集方式</th>
            <th>第三方隐私政策</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in tableData" :key="index">
            <td>{{ item.sdkName }}</td>
            <td>{{ item.thirdParty }}</td>
            <td>{{ item.sharedInfo }}</td>
            <td>{{ item.useScene }}</td>
            <td>{{ item.permissionUse }}</td>
            <td>{{ item.usePurpose }}</td>
            <td>{{ item.collectMethod }}</td>
            <td>
              <a v-if="item.privacyPolicy" :href="item.privacyPolicy" target="_blank" class="privacy-link">
                {{ item.privacyPolicy }}
              </a>
              <span v-else>-</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="empty-state" v-if="tableData.length === 0">
      <p>暂无第三方信息共享数据</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      personalInfoData: [
        {
          infoType: '位置信息',
          specificContent: '精确位置（经纬度）、粗略位置、后台位置',
          collectPurpose: '1.徒步轨迹实时记录和保存\n2. 发现附近的徒步好友\n3. 地图导航和路线规划',
          useScene: '徒步记录、地图浏览'
        },
        {
          infoType: '健康数据',
          specificContent: '步数、心率、运动识别',
          collectPurpose: '1.提供健康分析服务\n2. 记录和统计运动数据\n3. 生成健康报告',
          useScene: '运动统计'
        },
        {
          infoType: '相册和相机',
          specificContent: '照片、视频、媒体文件',
          collectPurpose: '1.记录徒步标记点图片\n2. 分享徒步照片和视频\n3. 设置用户头像',
          useScene: '拍照标记、内容分享、个人资料编辑'
        },
        {
          infoType: '账户信息',
          specificContent: '手机号码\n昵称\n头像\n生日\n性别\n身高\n体重',
          collectPurpose: '1.账号注册和登录\n2. 个人资料展示\n3. 提供个性化服务\n4. 计算运动消耗',
          useScene: '注册登录、个人中心'
        },
        {
          infoType: '行为数据',
          specificContent: '用户操作行为、徒步记录数据、应用使用时长',
          collectPurpose: '1.改进产品体验\n2. 数据统计分析\n3. 功能优化',
          useScene: '全局'
        }
      ],
      tableData: [
        {
          sdkName: '高德开放平台定位SDK',
          thirdParty: '北京高德图强科技有限公司',
          sharedInfo: '经纬度、设备信息【如IP 地址、GNSS信息、网络类型、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、WiFi信号强度的信息传感器信息（矢量、加速度、压力）、设备信号强度信息】、设备标识信息（IDFA、OAID）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（设备品牌及型号、操作系统、运营商信息、屏幕分辨率）',
          useScene: '',
          permissionUse: 'Android：位置、始终允许访问位置、网络访问\niOS：定位、始终允许访问位置、网络访问广告标识',
          usePurpose: '为了向用户提供定位服务',
          collectMethod: 'SDK本机采集',
          privacyPolicy: 'https://lbs.amap.com/pages/privacy/'
        },
        {
          sdkName: '高德开放平台地图SDK（合包）',
          thirdParty: '北京高德图强科技有限公司',
          sharedInfo: '经纬度、设备信息【如IP 地址、GNSS信息、网络类型、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、WiFi信号强度的信息传感器信息（矢量、加速度、压力、方向、地磁）、设备信号强度信息】、设备标识信息（IDFA、OAID）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（设备品牌及型号、操作系统、运营商信息、屏幕分辨率）、搜索词',
          useScene: '',
          permissionUse: 'Android：位置、始终允许访问位置、网络访问\niOS：定位、始终允许访问位置、网络访问广告标识',
          usePurpose: '为了实现地图展示、定位、搜索等服务',
          collectMethod: 'SDK本机采集',
          privacyPolicy: 'https://lbs.amap.com/pages/privacy/'
        },
        {
          sdkName: 'TalkingData SDK',
          thirdParty: '友盟同欣（北京）科技有限公司',
          sharedInfo: '唯一设备识别符(OAID，MAC，SN，AndroidID和ODID)、IP地址、IDFV、IDFA、SDK或API版本、平台、时间戳、系统文件的创建时间、应用标识符、应用程序版本、应用分发渠道、应用进程信息、应用的IDFA授权状态、应用的NFC权限情况(是或否)、设备是否支持NFC功能(是或否)、设备是否支持蓝牙功能(是或否)、设备型号、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、移动网络/国家代码、时区、硬盘、CPU和电池使用情况',
          useScene: '',
          permissionUse: '网络\nIDFA\n用于允许应用程序联网和发送数据\n用于生成脱敏的终端用户唯一标识。',
          usePurpose: '用于生成脱敏的终端用户唯一标识，进行基础分析。\n用于进行粗略的多维分析、提供分地区和应用版本号的数据报表。\n更准确地标识用户、识别作弊流量;收集应用列表用于识别、分析、剔除作弊流量。',
          collectMethod: 'SDK采集上报',
          privacyPolicy: 'http://gank.io/post/560e15be2dca930e00da1083'
        }
      ]
    }
  },
  mounted() {
    document.title = '新奇天户外app隐私协议'
    console.log('新奇天户外app隐私协议页面已加载')
    // 隐藏加载动画，显示内容
    setTimeout(() => {
      const loading = document.querySelector('.loading')
      const app = document.querySelector('#app')
      if (loading) {
        loading.style.display = 'none'
      }
      if (app) {
        app.style.display = 'block'
      }
    }, 300)
  }
}
</script>

<style lang="scss" scoped>
.personal-info-collection,
.third-party-info-sharing {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 40px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}
strong {
  font-weight: bolder;
}
.header {
  text-align: center;
  margin-bottom: 60px;
  padding: 40px 0;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);

  h1 {
    font-size: 48px;
    color: #333;
    font-weight: 600;
  }
}

.table-container {
  background-color: #fff;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

.table-wrapper {
  min-width: 1400px;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 28px;

  th, td {
    padding: 24px 16px;
    text-align: left;
    border-bottom: 2px solid #e0e0e0;
    vertical-align: top;
    word-wrap: break-word;
    min-width: 200px;
    white-space: pre-wrap;
    line-height: 1.5;
  }

  th {
    background-color: #f8f9fa;
    font-weight: 600;
    color: #333;
    font-size: 30px;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  tr:hover {
    background-color: #f8f9fa;
  }

  tr:last-child {
    td {
      border-bottom: none;
    }
  }
}

.privacy-link {
  color: #007aff;
  text-decoration: underline;
  word-break: break-all;

  &:hover {
    color: #0056b3;
  }

  &:active {
    color: #004085;
  }
}

.empty-state {
  text-align: center;
  padding: 100px 0;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);

  p {
    font-size: 32px;
    color: #666;
  }
}

@media (max-width: 768px) {
  .personal-info-collection,
  .third-party-info-sharing {
    padding: 30px;
  }

  .header {
    margin-bottom: 40px;
    padding: 30px 0;

    h1 {
      font-size: 40px;
    }
  }

  .table-container {
    padding: 30px;
  }

  .info-table {
    font-size: 24px;

    th, td {
      padding: 20px 12px;
      min-width: 160px;
    }

    th {
      font-size: 26px;
    }
  }

  .empty-state {
    padding: 80px 0;

    p {
      font-size: 28px;
    }
  }
}

@media (max-width: 480px) {
  .personal-info-collection,
  .third-party-info-sharing {
    padding: 20px;
  }

  .header {
    margin-bottom: 30px;
    padding: 20px 0;

    h1 {
      font-size: 32px;
    }
  }

  .table-container {
    padding: 20px;
  }

  .info-table {
    font-size: 20px;

    th, td {
      padding: 16px 8px;
      min-width: 120px;
    }

    th {
      font-size: 22px;
    }
  }

  .empty-state {
    padding: 60px 0;

    p {
      font-size: 24px;
    }
  }
}
</style>
